/*=============================================== WrapperPagination ===============================================*/

import { Wrapper, Main } from "tsx-library-julseb"

import WrapperDemo from "./WrapperDemo"

const WrapperPagination = ({ title, children }: WrapperPaginationProps) => {
    return (
        <WrapperDemo title={title}>
            <Wrapper>
                <Main size="large">{children}</Main>
            </Wrapper>
        </WrapperDemo>
    )
}

export default WrapperPagination

interface WrapperPaginationProps {
    title: string
    children?: any
}
